import gql from 'graphql-tag';

const GET_CARRIERS = gql`
    query getCarriers  {
        getCarriers {
            carrier
            category
            time
        }
    }
`;

export default GET_CARRIERS;
